export default [
    {
        path: "/accounts",
        name: "accounts",
        component: () => import("@/views/modules/accounts/accounts"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Accounts",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Accounts" },
            ],
        },
    },

    {
        path: "/accounts-invoices/",
        name: "accounts-invoices",
        component: () => import("@/views/modules/accounts/invoices"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Invoices",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Invoices" },
            ],
        },
        children:[
            {
            
                path: "/accounts-invoices/create",
                name: "accounts-invoices-create",
                component: () => import("@/views/modules/accounts/invoiceCreate"),
                meta: {
                    sidebarToggle: true,
                    requiresAuth: true,
                    layout: "app",
                    title: "Ad-hoc Invoice Create",
                    breadcrumb: [
                        { text: "Home", to: { name: "home" } },
                        { text: 'Invoices', link: '/accounts-invoices' },
                    { text: 'Create' }
                    ],
                },
            },
        ]
    },

    

    {
        path: "/accounts-payments",
        name: "accounts-payments",
        component: () => import("@/views/modules/accounts/payments"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Payments",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Payments" },
            ],
        },
    },

    

    {
        path: "/accounts-credits",
        name: "accounts-credits",
        component: () => import("@/views/modules/accounts/credits"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Credits",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Credits" },
            ],
        },
    },

    {
        path: "/accounts-debits",
        name: "accounts-debits",
        component: () => import("@/views/modules/accounts/debits"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Debits",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Debits" },
            ],
        },
    },

    {
        path: "/accounts/:id/account",
        name: "accounts-account",
        props: true,
        component: () => import("@/views/modules/accounts/account"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Account",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Accounts", to: { name: "accounts" } },
                { text: "Account" },
            ],
        },
    },

    
];
